import '../../styles/tools.css';
import { SiteLink as Link } from '../../components/SiteLink';
import { PageShell, GetStarted } from '../../components';
import { PageBody, PageHero } from '../../components/page';
import { TOOLS, toolPath } from '../../tools/registry';

/** statio.dev/tools. Free tools, listed from src/tools/registry.ts. */
export default function ToolsIndex() {
  return (
    <PageShell>
      <PageBody>
        <PageHero
          title="Free MCP tools"
          lede="Small tools for working with MCP servers and AI agent access, which run in your browser with no account needed."
        />
        <section className="bl-index" aria-label="Tools">
          {TOOLS.length === 0 ? (
            <p className="pg-caption">The first tools are on the way.</p>
          ) : (
            <ul>
              {TOOLS.map((t) => (
                <li key={t.slug} className="tl-card">
                  <div>
                    <h2>
                      <Link to={toolPath(t.slug)}>{t.h1}</Link>
                    </h2>
                    <p>{t.value}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>
      </PageBody>
      <GetStarted />
    </PageShell>
  );
}
